module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDAgMAAAAXJUhJAAAADFBMVEXtKTntKTn4q7H////BGehuAAAAAXRSTlPUwVjOqwAAACdJREFUeAFjYcAFWEJxyoCIUZlRmVAy086ozKjMatwy5NkzKjOadgD63QQN7gpCVwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/at.png
// module id = uIwr
// module chunks = 0